import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {goToPage, updateDocumentTitle} from "../../Utils/Common";
import {useHistory} from "react-router-dom";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, Checkbox, FormField, Select, TextInput} from "../UI";

const CountryForm = props => {

    let history = useHistory();
    const countryId = props.match && props.match.params ? props.match.params.id : null;
    const isEdit = !!countryId;

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [currency, setCurrency] = useState('');
    const [currencySymbol, setCurrencySymbol] = useState('');
    const [dialCode, setDialCode] = useState('');
    const [mpesaEnabled, setMpesaEnabled] = useState(false);
    const [paystackAccount, setPaystackAccount] = useState('default');
    const [status, setStatus] = useState(1);

    useEffect(() => {
        updateDocumentTitle(isEdit ? "Edit country" : "Add new country");
        if (isEdit) {
            let data = new FormData();
            data.append("id", countryId);
            postData(Endpoints.COUNTRY_DETAIL, data)
                .then(res => res.json())
                .then(res => {
                    if (res.success === 1 && res.data) {
                        const c = res.data;
                        setName(c.name || '');
                        setCode(c.code || '');
                        setCurrency(c.currency || '');
                        setCurrencySymbol(c.currency_symbol || '');
                        setDialCode(c.dial_code || '');
                        setMpesaEnabled(!!c.mpesa_enabled);
                        setPaystackAccount(c.paystack_account || 'default');
                        setStatus(typeof c.status === 'number' ? c.status : 1);
                    }
                })
                .catch(error => console.log(error));
        }
    }, [countryId]);

    const submitForm = e => {
        e.preventDefault();

        let data = new FormData();
        if (isEdit) {
            data.append("id", countryId);
        }
        data.append("name", name);
        data.append("code", code);
        data.append("currency", currency);
        data.append("currency_symbol", currencySymbol);
        data.append("dial_code", dialCode);
        data.append("mpesa_enabled", mpesaEnabled);
        data.append("paystack_account", paystackAccount);
        data.append("status", status);

        setIsLoading(true);

        postData(isEdit ? Endpoints.COUNTRY_UPDATE_DETAILS : Endpoints.COUNTRY_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify(res.data, SUCCESS);
                    goToPage(history, "/countries");
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error);
            });
    };

    return (
        <PageLayout
            title={isEdit ? "Edit country" : "Create a new country"}
            actions={
                <Link to="/countries">
                    <Button variant="outline">Back to countries</Button>
                </Link>
            }
        >
            <Card style={{maxWidth: 620}}>
                <form>
                    <FormField label="Name" required>
                        <TextInput type="text" required placeholder="e.g. Kenya"
                                   value={name} onChange={e => setName(e.target.value)}/>
                    </FormField>

                    <FormField label="Code (ISO alpha-2)" required hint="Two-letter country code, e.g. KE or ZA">
                        <TextInput type="text" required placeholder="KE" maxLength={2}
                                   value={code} onChange={e => setCode(e.target.value.toUpperCase())}/>
                    </FormField>

                    <FormField label="Currency (ISO-4217)" required hint="Three-letter currency code, e.g. KES or ZAR">
                        <TextInput type="text" required placeholder="KES" maxLength={3}
                                   value={currency} onChange={e => setCurrency(e.target.value.toUpperCase())}/>
                    </FormField>

                    <FormField label="Currency symbol">
                        <TextInput type="text" placeholder="KSh"
                                   value={currencySymbol} onChange={e => setCurrencySymbol(e.target.value)}/>
                    </FormField>

                    <FormField label="Dial code" hint="Without the leading +, e.g. 254">
                        <TextInput type="text" placeholder="254"
                                   value={dialCode} onChange={e => setDialCode(e.target.value)}/>
                    </FormField>

                    <FormField label="PayStack account" hint="Which PayStack credentials settle charges for this country">
                        <Select value={paystackAccount} onChange={e => setPaystackAccount(e.target.value)}>
                            <option value="default">default</option>
                            <option value="za">za (South Africa)</option>
                        </Select>
                    </FormField>

                    <FormField label="Status">
                        <Select value={status} onChange={e => setStatus(parseInt(e.target.value, 10))}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </Select>
                    </FormField>

                    <FormField label="Payment rails">
                        <Checkbox
                            checked={mpesaEnabled}
                            onChange={e => setMpesaEnabled(e.target.checked)}
                            label="Offer M-Pesa in this country"
                        />
                    </FormField>

                    <Button type="submit" loading={isLoading} onClick={e => submitForm(e)}>
                        {isEdit ? "Save changes" : "Create"}
                    </Button>
                </form>
            </Card>
        </PageLayout>
    );
};

export default CountryForm;
